<template>
  <div class="ohra-statistics-wrapper">
    <div class="statistics-header">
      <h2 class="statistics-title">OHRA Statistics</h2>
      <div class="date-picker-container">
        <ohra-date-picker
          range
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.all')"
        />
      </div>
    </div>

    <div class="statistics-content">
      <div class="statistics-card">
        <ohra-order-details-card :range="formatedRange" />
      </div>
      <div class="statistics-card">
        <ohra-status-breakdown :range="formatedRange" />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "ohra-date-picker": DatePicker,
    "ohra-order-details-card": () =>
      import("@/components/dashboard/ohra/DetailsOrder.vue"),
    "ohra-status-breakdown": () =>
      import("@/components/dashboard/ohra/StatusBreakdown.vue")
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null]
    };
  },
  watch: {
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];
      } else {
        this.formatedRange = [null, null];
      }
    }
  }
};
</script>

<style scoped>
.ohra-statistics-wrapper {
  background-color: #f7f7f7;
  min-height: calc(100vh - 200px);
  padding: 24px;
}

.statistics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.statistics-title {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.date-picker-container {
  display: flex;
  align-items: center;
  background: white;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.statistics-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 24px;
}

.statistics-card {
  min-height: 200px;
}

@media (max-width: 768px) {
  .ohra-statistics-wrapper {
    padding: 16px;
  }

  .statistics-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .statistics-content {
    grid-template-columns: 1fr;
  }

  .date-picker-container {
    width: 100%;
  }
}
</style>
